<template>
  <b-modal :id="modalId" centered scrollable hide-header-close size="lg" no-close-on-backdrop
           modal-class="menus-modal bulk-modal" @show="reset">
    <template #modal-header="{ cancel }">
      <menu-modal-header icon="sliders" title="ویرایش گروهی محصولات"
                         :subtitle="step === 'preview' ? 'پیش‌نمایش تغییرات را بررسی و تایید کنید' : 'دامنه و نوع تغییر را انتخاب کنید'"
                         @close="cancel()"/>
    </template>

    <div v-if="step === 'form'" class="bulk-form">
      <div class="menus-modal-field">
        <label class="menus-modal-label">محصولات هدف</label>
        <div class="bulk-pills">
          <button type="button" class="bulk-pill" :class="{ 'is-active': scope === 'selected' }"
                  :disabled="!selectedCount" @click="scope = 'selected'">
            <b-icon icon="check2-square"></b-icon>
            <span>انتخاب‌شده‌ها</span>
            <em>{{ formatNumber(selectedCount) }}</em>
          </button>
          <button type="button" class="bulk-pill" :class="{ 'is-active': scope === 'filter' }" @click="scope = 'filter'">
            <b-icon icon="funnel"></b-icon>
            <span>نتایج فیلتر فعلی</span>
            <em v-if="filterTotal != null">{{ formatNumber(filterTotal) }}</em>
          </button>
          <button type="button" class="bulk-pill" :class="{ 'is-active': scope === 'all' }" @click="scope = 'all'">
            <b-icon icon="collection"></b-icon>
            <span>همه محصولات</span>
          </button>
        </div>
      </div>

      <div class="menus-modal-field">
        <label class="menus-modal-label">نوع تغییر</label>
        <div class="bulk-tabs">
          <button v-for="op in operations" :key="op.value" type="button" class="bulk-tab"
                  :class="{ 'is-active': operation === op.value }" @click="operation = op.value">
            <b-icon :icon="op.icon"></b-icon>
            <span>{{ op.text }}</span>
          </button>
        </div>
      </div>

      <div v-if="operation === 'price'" class="bulk-card">
        <div class="bulk-grid">
          <div class="menus-modal-field">
            <label>جهت تغییر</label>
            <div class="bulk-seg">
              <button type="button" :class="{ 'is-active': price.direction === 'increase' }" @click="price.direction = 'increase'">
                <b-icon icon="arrow-up"></b-icon> افزایش
              </button>
              <button type="button" :class="{ 'is-active': price.direction === 'decrease' }" @click="price.direction = 'decrease'">
                <b-icon icon="arrow-down"></b-icon> کاهش
              </button>
            </div>
          </div>
          <div class="menus-modal-field">
            <label>نوع مقدار</label>
            <div class="bulk-seg">
              <button type="button" :class="{ 'is-active': price.mode === 'percent' }" @click="price.mode = 'percent'">درصدی</button>
              <button type="button" :class="{ 'is-active': price.mode === 'fixed' }" @click="price.mode = 'fixed'">مبلغ ثابت</button>
            </div>
          </div>
          <div class="menus-modal-field">
            <label>{{ price.mode === 'percent' ? 'درصد' : 'مبلغ (تومان)' }}</label>
            <div class="bulk-amount" :class="price.mode === 'percent' ? 'is-percent' : 'is-fixed'">
              <input type="text" inputmode="decimal" dir="ltr" class="bulk-amount-input"
                     :value="amountDisplay" :placeholder="price.mode === 'percent' ? '10' : '150,000'"
                     @input="onAmountInput">
              <span class="bulk-amount-suffix">{{ price.mode === 'percent' ? '%' : 'تومان' }}</span>
            </div>
            <small class="menus-modal-help" v-if="price.mode === 'percent'">بین ۰ تا ۱۰۰۰، اعشار مجاز است.</small>
            <small class="menus-modal-help" v-else-if="price.value">{{ formatNumber(price.value) }} تومان</small>
          </div>
          <div class="menus-modal-field">
            <label>تخفیف محصولات</label>
            <b-form-select v-model="price.offer_mode" :options="offerModes"/>
          </div>
          <div class="menus-modal-field">
            <label>رُند کردن</label>
            <b-form-select v-model="price.rounding_step" :options="roundingSteps"/>
          </div>
          <div class="menus-modal-field" v-if="Number(price.rounding_step) > 0">
            <label>جهت رُند</label>
            <b-form-select v-model="price.rounding_direction" :options="roundingDirections"/>
          </div>
        </div>
      </div>

      <div v-if="operation === 'stock'" class="bulk-card">
        <div class="bulk-grid">
          <div class="menus-modal-field" v-if="stock.method !== 'adjust'">
            <label>وضعیت موجودی</label>
            <div class="bulk-seg">
              <button type="button" :class="{ 'is-active': stock.action === 'out_of_stock' }" @click="stock.action = 'out_of_stock'">ناموجود</button>
              <button type="button" :class="{ 'is-active': stock.action === 'in_stock' }" @click="stock.action = 'in_stock'">موجود</button>
            </div>
          </div>
          <div class="menus-modal-field">
            <label>روش</label>
            <b-form-select v-model="stock.method" :options="stockMethods"/>
          </div>
          <div class="menus-modal-field" v-if="stock.action === 'in_stock' && stock.method === 'quantity'">
            <label>تعداد جدید برای موجودی صفر</label>
            <b-form-input type="number" min="0" dir="ltr" class="text-left" v-model="stock.restock_quantity"
                          placeholder="خالی = نامحدود"/>
          </div>
          <template v-if="stock.method === 'adjust'">
            <div class="menus-modal-field">
              <label>جهت تغییر</label>
              <div class="bulk-seg">
                <button type="button" :class="{ 'is-active': stock.adjust_direction === 'increase' }" @click="stock.adjust_direction = 'increase'">
                  <b-icon icon="plus-lg"></b-icon> افزایش
                </button>
                <button type="button" :class="{ 'is-active': stock.adjust_direction === 'decrease' }" @click="stock.adjust_direction = 'decrease'">
                  <b-icon icon="dash-lg"></b-icon> کاهش
                </button>
              </div>
            </div>
            <div class="menus-modal-field">
              <label>تعداد</label>
              <div class="bulk-amount is-fixed">
                <input type="text" inputmode="numeric" dir="ltr" class="bulk-amount-input"
                       :value="adjustDisplay" placeholder="10" @input="onAdjustInput">
                <span class="bulk-amount-suffix">عدد</span>
              </div>
            </div>
            <div class="menus-modal-field">
              <label>وضعیت موجودی</label>
              <b-form-checkbox v-model="stock.sync_status" switch>
                با صفر شدن ناموجود و با بیشتر از صفر موجود شود
              </b-form-checkbox>
            </div>
          </template>
        </div>
        <small class="menus-modal-help">{{ stockHelp }}</small>
      </div>

      <div v-if="operation === 'status'" class="bulk-card">
        <div class="menus-modal-field mb-0">
          <label>وضعیت انتشار</label>
          <div class="bulk-seg">
            <button type="button" :class="{ 'is-active': Number(status) === 1 }" @click="status = 1">
              <b-icon icon="eye"></b-icon> منتشر شده
            </button>
            <button type="button" :class="{ 'is-active': Number(status) === 0 }" @click="status = 0">
              <b-icon icon="eye-slash"></b-icon> پیش‌نویس
            </button>
          </div>
        </div>
      </div>

      <p v-if="formError" class="bulk-error">{{ formError }}</p>
    </div>

    <div v-else-if="step === 'preview' && preview" class="bulk-preview">
      <div class="bulk-stats">
        <div class="bulk-stat">
          <strong>{{ formatNumber(preview.products_count) }}</strong>
          <span>محصول</span>
        </div>
        <div class="bulk-stat" v-if="operation !== 'status'">
          <strong>{{ formatNumber(preview.variants_count) }}</strong>
          <span>تنوع</span>
        </div>
        <div class="bulk-stat is-wide">
          <span>{{ summaryText }}</span>
        </div>
      </div>

      <p class="bulk-sample-title">نمونه تغییرات (حداکثر ۸ محصول)</p>
      <div v-if="!preview.sample || !preview.sample.length" class="bulk-empty">محصولی برای نمایش وجود ندارد.</div>
      <div v-for="row in preview.sample" :key="'s-' + row.id" class="bulk-sample">
        <div class="bulk-sample-head">
          <span class="menus-id-chip">#{{ row.id }}</span>
          <strong>{{ row.name }}</strong>
        </div>
        <div class="bulk-diff">
          <div v-for="field in visibleFields" :key="row.id + field.key" class="bulk-diff-item"
               :class="{ 'is-changed': isChanged(row.before[field.key], row.after[field.key]) }">
            <span>{{ field.text }}</span>
            <bulk-value-change :old-text="display(field, row.before[field.key])" :new-text="display(field, row.after[field.key])"
                               :changed="isChanged(row.before[field.key], row.after[field.key])"/>
          </div>
        </div>
        <div v-if="row.variants && row.variants.length" class="bulk-variants">
          <div v-for="variant in row.variants" :key="'v-' + variant.id" class="bulk-variant">
            <span class="bulk-variant-name">تنوع #{{ variant.id }}</span>
            <template v-for="field in variantFields">
              <span :key="variant.id + field.key" class="bulk-variant-val"
                    :class="{ 'is-changed': isChanged(variant.before[field.key], variant.after[field.key]) }">
                <span class="bulk-variant-label">{{ field.text }}</span>
                <bulk-value-change :old-text="display(field, variant.before[field.key])" :new-text="display(field, variant.after[field.key])"
                                   :changed="isChanged(variant.before[field.key], variant.after[field.key])"/>
              </span>
            </template>
          </div>
          <small v-if="row.variants_count > row.variants.length" class="menus-modal-help">
            و {{ formatNumber(row.variants_count - row.variants.length) }} تنوع دیگر
          </small>
        </div>
      </div>
      <p class="bulk-warn">
        <b-icon icon="info-circle"></b-icon>
        این عملیات در تاریخچه ویرایش گروهی ثبت می‌شود و قابل بازگردانی است.
      </p>
    </div>

    <template #modal-footer="{ cancel }">
      <div class="menus-modal-actions">
        <template v-if="step === 'form'">
          <button type="button" class="menus-btn is-primary" :disabled="loading" @click="loadPreview">
            <b-spinner v-if="loading" small></b-spinner>
            <b-icon v-else icon="eye"></b-icon>
            <span>پیش‌نمایش</span>
          </button>
          <button type="button" class="menus-btn" :disabled="loading" @click="cancel()">انصراف</button>
        </template>
        <template v-else>
          <button type="button" class="menus-btn is-primary" :disabled="loading || !preview || !preview.products_count"
                  @click="applyChanges">
            <b-spinner v-if="loading" small></b-spinner>
            <b-icon v-else icon="check2"></b-icon>
            <span>تایید و اعمال</span>
          </button>
          <button type="button" class="menus-btn" :disabled="loading" @click="step = 'form'">
            <b-icon icon="arrow-right"></b-icon>
            <span>بازگشت</span>
          </button>
        </template>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {mapGetters} from "vuex";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import MenuModalHeader from "../menu/MenuModalHeader.vue";
import BulkValueChange from "./BulkValueChange.vue";
import "../menu/menus-ui.css";
import "./bulk-edit-ui.css";

const FIELDS = {
  price: {key: 'price', text: 'قیمت', money: true},
  offer: {key: 'offer', text: 'تخفیف', money: true},
  quantity: {key: 'quantity', text: 'تعداد', qty: true},
  quantity_status: {key: 'quantity_status', text: 'موجودی', stock: true},
  status: {key: 'status', text: 'انتشار', publish: true},
}

export default {
  name: "ProductBulkEditModal",
  components: {MenuModalHeader, BulkValueChange},
  props: {
    modalId: {
      type: String,
      default: 'product-bulk-edit-modal'
    },
    filterTotal: {
      default: null
    }
  },
  data() {
    return {
      step: 'form',
      loading: false,
      formError: '',
      preview: null,
      scope: 'filter',
      operation: 'price',
      operations: [
        {value: 'price', text: 'قیمت', icon: 'cash-coin'},
        {value: 'stock', text: 'موجودی', icon: 'box-seam'},
        {value: 'status', text: 'انتشار', icon: 'eye'},
      ],
      price: {
        mode: 'percent',
        direction: 'increase',
        value: '',
        offer_mode: 'scale',
        rounding_step: 0,
        rounding_direction: 'nearest',
      },
      stock: {
        action: 'out_of_stock',
        method: 'status',
        restock_quantity: '',
        adjust_direction: 'increase',
        adjust_amount: '',
        sync_status: true,
      },
      status: 1,
      offerModes: [
        {value: 'scale', text: 'به همان نسبت تغییر کند'},
        {value: 'fixed', text: 'ثابت بماند'},
      ],
      roundingSteps: [
        {value: 0, text: 'بدون رُند'},
        {value: 100, text: '۱۰۰ تومان'},
        {value: 1000, text: '۱٬۰۰۰ تومان'},
        {value: 10000, text: '۱۰٬۰۰۰ تومان'},
      ],
      roundingDirections: [
        {value: 'nearest', text: 'نزدیک‌ترین'},
        {value: 'up', text: 'رو به بالا'},
        {value: 'down', text: 'رو به پایین'},
      ],
      stockMethods: [
        {value: 'status', text: 'فقط تغییر وضعیت موجودی'},
        {value: 'quantity', text: 'صفر / پر کردن موجودی'},
        {value: 'adjust', text: 'افزایش / کاهش تعداد'},
      ],
    }
  },
  computed: {
    ...mapGetters({
      selectedCount: 'ProductBulkEdit/selectedCount',
    }),
    amountDisplay() {
      const value = String(this.price.value == null ? '' : this.price.value)
      if (this.price.mode === 'fixed') {
        return value ? value.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
      }
      return value
    },
    adjustDisplay() {
      const value = String(this.stock.adjust_amount == null ? '' : this.stock.adjust_amount)
      return value ? value.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
    },
    stockHelp() {
      if (this.stock.method === 'adjust') {
        return 'تعداد محصولات ساده و تنوع‌ها به اندازه واردشده تغییر می‌کند (حداقل صفر). موارد نامحدود تغییر نمی‌کنند.'
      }
      if (this.stock.method === 'status') {
        return 'فقط وضعیت موجود/ناموجود محصولات و تنوع‌ها تغییر می‌کند و تعدادها دست نمی‌خورند.'
      }
      return this.stock.action === 'out_of_stock'
          ? 'تعداد محصولات ساده و تنوع‌ها صفر و وضعیت ناموجود می‌شود.'
          : 'موارد با تعداد صفر به تعداد واردشده (یا نامحدود) تغییر می‌کنند و وضعیت موجود می‌شود.'
    },
    params() {
      if (this.operation === 'price') {
        return {
          mode: this.price.mode,
          direction: this.price.direction,
          value: Number(this.price.value),
          offer_mode: this.price.offer_mode,
          rounding_step: Number(this.price.rounding_step),
          rounding_direction: this.price.rounding_direction,
        }
      }
      if (this.operation === 'stock') {
        if (this.stock.method === 'adjust') {
          return {
            method: 'adjust',
            adjust_direction: this.stock.adjust_direction,
            adjust_amount: Number(this.stock.adjust_amount),
            sync_status: Boolean(this.stock.sync_status),
          }
        }
        const params = {action: this.stock.action, method: this.stock.method}
        if (this.stock.restock_quantity !== '' && this.stock.restock_quantity !== null) {
          params.restock_quantity = Number(this.stock.restock_quantity)
        }
        return params
      }
      return {status: Number(this.status)}
    },
    visibleFields() {
      if (this.operation === 'price') return [FIELDS.price, FIELDS.offer]
      if (this.operation === 'stock') return [FIELDS.quantity, FIELDS.quantity_status]
      return [FIELDS.status]
    },
    variantFields() {
      if (this.operation === 'price') return [FIELDS.price, FIELDS.offer]
      return [FIELDS.quantity]
    },
    summaryText() {
      const scopeText = {selected: 'محصولات انتخاب‌شده', filter: 'نتایج فیلتر فعلی', all: 'همه محصولات'}[this.scope]
      if (this.operation === 'price') {
        const amount = this.price.mode === 'percent' ? `${this.price.value}٪` : `${formatNumber(this.price.value)} تومان`
        return `${this.price.direction === 'increase' ? 'افزایش' : 'کاهش'} قیمت ${amount} — ${scopeText}`
      }
      if (this.operation === 'stock') {
        if (this.stock.method === 'adjust') {
          return `${this.stock.adjust_direction === 'decrease' ? 'کاهش' : 'افزایش'} ${formatNumber(this.stock.adjust_amount)} عدد موجودی — ${scopeText}`
        }
        return `${this.stock.action === 'out_of_stock' ? 'ناموجود کردن' : 'موجود کردن'} — ${scopeText}`
      }
      return `${Number(this.status) === 1 ? 'انتشار' : 'عدم انتشار'} — ${scopeText}`
    },
  },
  watch: {
    'price.mode'(mode) {
      this.price.value = this.sanitizeAmount(this.price.value, mode)
    },
  },
  methods: {
    formatNumber,
    normalizeDigits(value) {
      return String(value == null ? '' : value)
          .replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
          .replace(/[٠-٩]/g, (d) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)))
          .replace(/[٫/]/g, '.')
    },
    sanitizeAmount(raw, mode) {
      let value = this.normalizeDigits(raw)
      if (mode === 'fixed') {
        value = value.replace(/[^0-9]/g, '').replace(/^0+(?=\d)/, '')
        return value.slice(0, 12)
      }
      value = value.replace(/[^0-9.]/g, '')
      const dot = value.indexOf('.')
      if (dot !== -1) {
        value = value.slice(0, dot + 1) + value.slice(dot + 1).replace(/\./g, '').slice(0, 2)
      }
      value = value.replace(/^0+(?=\d)/, '')
      if (Number(value) > 1000) {
        value = '1000'
      }
      return value
    },
    onAmountInput(event) {
      const value = this.sanitizeAmount(event.target.value, this.price.mode)
      this.price.value = value
      const display = this.amountDisplay
      if (event.target.value !== display) {
        event.target.value = display
      }
    },
    onAdjustInput(event) {
      this.stock.adjust_amount = this.sanitizeAmount(event.target.value, 'fixed').slice(0, 8)
      const display = this.adjustDisplay
      if (event.target.value !== display) {
        event.target.value = display
      }
    },
    reset() {
      this.step = 'form'
      this.preview = null
      this.formError = ''
      this.loading = false
      this.scope = this.selectedCount ? 'selected' : 'filter'
    },
    validate() {
      if (this.scope === 'selected' && !this.selectedCount) {
        return 'هیچ محصولی انتخاب نشده است.'
      }
      if (this.operation === 'price') {
        const value = Number(this.price.value)
        if (!(value > 0)) {
          return 'مقدار تغییر قیمت را وارد کنید.'
        }
        if (this.price.mode === 'percent' && this.price.direction === 'decrease' && value >= 100) {
          return 'کاهش درصدی باید کمتر از ۱۰۰ باشد.'
        }
        if (this.price.mode === 'percent' && value > 1000) {
          return 'درصد تغییر نمی‌تواند بیشتر از ۱۰۰۰ باشد.'
        }
      }
      if (this.operation === 'stock' && this.stock.method === 'adjust') {
        const amount = Number(this.stock.adjust_amount)
        if (!Number.isInteger(amount) || amount < 1) {
          return 'تعداد تغییر موجودی را وارد کنید.'
        }
        if (amount > 10000000) {
          return 'تعداد تغییر موجودی بیش از حد مجاز است.'
        }
      }
      if (this.operation === 'stock' && this.stock.restock_quantity !== '' && Number(this.stock.restock_quantity) < 0) {
        return 'تعداد نمی‌تواند منفی باشد.'
      }
      return ''
    },
    payload() {
      return {scope: this.scope, operation: this.operation, params: this.params}
    },
    errorMessage(error) {
      const data = error && error.response && error.response.data
      return (data && (data.message || data.error)) || 'خطا در ارتباط با سرور'
    },
    async loadPreview() {
      this.formError = this.validate()
      if (this.formError) return
      this.loading = true
      try {
        this.preview = await this.$store.dispatch('ProductBulkEdit/preview', this.payload())
        this.step = 'preview'
      } catch (e) {
        this.formError = this.errorMessage(e)
      } finally {
        this.loading = false
      }
    },
    async applyChanges() {
      if (!confirm(`تغییرات روی ${formatNumber(this.preview.products_count)} محصول اعمال شود؟`)) return
      this.loading = true
      try {
        const result = await this.$store.dispatch('ProductBulkEdit/apply', this.payload())
        toast('ویرایش گروهی انجام شد', `${formatNumber(result.products_count || 0)} محصول و ${formatNumber(result.variants_count || 0)} تنوع به‌روزرسانی شد`)
        if (this.scope === 'selected') {
          this.$store.dispatch('ProductBulkEdit/clear')
        }
        this.$emit('applied', result)
        this.$bvModal.hide(this.modalId)
      } catch (e) {
        this.step = 'form'
        this.formError = this.errorMessage(e)
      } finally {
        this.loading = false
      }
    },
    isChanged(before, after) {
      return String(before) !== String(after)
    },
    display(field, value) {
      if (field.money) return value === null || value === undefined ? '—' : formatNumber(value)
      if (field.qty) return value === null || value === undefined ? 'نامحدود' : formatNumber(value)
      if (field.stock) return Number(value) === 1 ? 'موجود' : 'ناموجود'
      if (field.publish) return Number(value) === 1 ? 'منتشر' : 'پیش‌نویس'
      return value
    },
  },
}
</script>
